import TextAlignPicker from './index.vue';

TextAlignPicker.install = function(Vue) {
  Vue.component(TextAlignPicker.name, TextAlignPicker);
};

export default TextAlignPicker; 